export default defineNuxtPlugin(async (nuxtApp) => {
  // Load system settings during app initialization
  try {
    const { $api } = nuxtApp

    // Initialize the system settings state
    const systemSettings = useState('system-settings', () => ({}))

    // Load settings asynchronously
    $api('/system')
      .then((response) => {
        if (response?.settings) {
          systemSettings.value = response.settings
        }
      })
      .catch((error) => {
        console.warn('Failed to load system settings:', error)
      })
  } catch (error) {
    console.warn('System settings plugin initialization failed:', error)
  }
})
